import React, { Component} from 'react';
// , useEffect, useState
// import ReactTooltip from 'react-tooltip';
import { Row, Col, Modal, Button } from 'react-bootstrap';
// FormControl, InputGroup, Dropdown, DropdownButton, SplitButton, Container,
import { apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// org_uuid, user_entity_uuid,
import axios from "axios";

//import React, { Component } from 'react';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import PKButton from 'components/Button/PKButton';
//import 'components/CreateUser/style.css';

import { get_link_base_url } from 'utils/Helper';

//import "pages/City/CityInfo/style.css";
//import "pages/CreateEvent/Steps/Presenters/style.css";
import './style.css';

// import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
//import axios from 'axios';
import { locationSearchAPI } from "Api/Api";
import avatar from 'Assets/avatarnew.svg';

import UserContext from 'store/UserContext';

class CreateNewUserModal extends Component {
    static contextType = UserContext;
    
    constructor(props) {
        super(props);
        this.state = {
            message: <React.Fragment></React.Fragment>,
            country_options: [],
            city_options: [],
            country_city_options_obj: {},
            user_data: {
                firstname: '',
                lastname: '',
                email: '',
                occupation: '',
                employer: '',
                website_url: '',
                description: ''
            },
            selected_country_option: null,
            selected_city_option: null,
            imagePreviewUrl: null,
            file: null,
            loading: true,
            validated: false,
        };
        this.country_city_options_obj = {};
    }

    componentDidMount = async function () {
        // get PK city data for dropdowns
        console.log("CreateNewUserModal componentDidMount");
        let tmp_bypass_workspace_api_headers = {
            headers: {
                'X-PK-Organization': ""
            }
        };
        
        let all_locations_response = await axios.get(`${locationSearchAPI}?coordinates_lat=0&coordinates_lon=0&radius=20038`,tmp_bypass_workspace_api_headers);
        let all_locations_data = all_locations_response.data.search_query_results.map((data) => data.entity_info);
        
        // convert into dropdown structure
        let country_city_options_obj = {};
        for (let location_obj of all_locations_data) {
            if (!country_city_options_obj[location_obj.country]) {
                country_city_options_obj[location_obj.country] = [];
            }
            country_city_options_obj[location_obj.country].push(location_obj);
        }
        
        let country_options = [];
        let selected_country_option = "";
        let selected_city_option = "";
        for (let country of Object.keys(country_city_options_obj).sort()) {
            let country_option = {
                value: country,
                label: country,
            };
            let city_options = [];
            for (let city_obj of country_city_options_obj[country].sort((a, b) => a.entity_name.localeCompare(b.entity_name))) {
                let city_option = {
                    value: city_obj.entity_uuid,
                    label: city_obj.entity_name
                }
                city_options.push(city_option);
                
                // does it match the logged-in user's resident location?
                if (this.context.user_info.resident_locations && this.context.user_info.resident_locations[0] && this.context.user_info.resident_locations[0].entity_uuid === city_obj.entity_uuid) {
                  selected_country_option = country_option.value;
                  selected_city_option = city_option.value;
                }
                //if (this.props.user_data.locations && this.props.user_data.locations[0] && this.props.user_data.locations[0].entity_uuid && this.props.user_data.locations[0].entity_uuid === city_obj.entity_uuid) {
                //    selected_country_option = country_option.value;
                //    selected_city_option = city_option.value;
                //}
            }
            country_options.push(country_option);
            this.country_city_options_obj[country] = city_options;
        }
        if (!selected_country_option || !selected_city_option) {
            selected_country_option = 'Japan';
            //selected_city_option = this.country_city_options_obj[selected_country_option][0].value;
            selected_city_option = 'Tokyo';
        }
        this.setState({
            country_options,
            city_options: this.country_city_options_obj[selected_country_option],
            selected_country_option,
            selected_city_option,
            loading: false
        });
    }

    // generic handler for <Form> fields
    handleChangeFormValue = (event) => {
        let updated_user_data = {...this.state.user_data};

        updated_user_data[event.target.id] = event.target.value;
        this.setState({
            user_data: updated_user_data,
            message: <React.Fragment></React.Fragment>
        });
    }

    handleChangeCountry = (event) => {
        this.setState({
            selected_country_option: event.target.value,
            city_options: this.country_city_options_obj[event.target.value]
        });
    }
    
    handleChangeCity = (event) => {
        console.log("handleChangeCity",event.target.value);
        this.setState({
            selected_city_option: event.target.value
        });
    }

    // Change Avatar method
    onChangeFile = (event) => {
        event.stopPropagation();
        event.preventDefault();
        let files = event.target.files;
        var index;
        for (index = 0; index < files.length; index++) {
            var file = files[index];
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState(() => ({
                    imagePreviewUrl: reader.result
                }));
            };
            reader.readAsDataURL(file);
        }
        this.setState({
          file
        }); 
    };

    handleSubmitNewUser = (event) => {
        console.log("handleSubmitNewUser");
        event.preventDefault();
        event.stopPropagation();

        this.setState({
            validated: true
        });

        let form = event.currentTarget;
        if (form.checkValidity() === false) {
            console.log("invalid");
            return;
        }

        // prepare locations.audience
        let new_user_data = {...this.state.user_data};
        new_user_data['locations.audience'] = [
            {
                entity_uuid: this.state.selected_city_option,
                xref_data: {
                    resident_integer: 1
                }
            }
        ];
        
        console.log("new_user_data",new_user_data);
        //return;
        this.createNewUser(new_user_data,this.state.file);
        
        //this.onHide();
        
        return;
        
    }

    // finish "CreateUser" component
    createNewUser = async (data,file = null) => {
        this.setState({ 
            loading: true,
            message: <span style={{color:"darkgray", paddingTop: "10px"}}>Working...</span>,
            //userCollisionError: null
        });
        
        console.log("createNewUser",data);
        if (data === undefined) {
            console.log("createNewUser no data");
            return;
        }
        let collison_check_obj = {
            email: data.email
        };
        
        let collision_check_response = await axios.post(`${apiUrl}users/checkUniqueCollision`, collison_check_obj);
        if (collision_check_response.data.email === true) {
            console.log("Found email collision");
            this.setState({
                message: <span style={{color:"red", paddingTop: "10px"}}>Sorry, this email is already associated with an existing account</span>,
                //userCollisionError: "Sorry, this email is already associated with an existing account",
                //add_user_section_loading:false
                loading: false
            });
            return;
        }

        //this.onClickToggleAddUser();
        
        //this.setState({
            //add_user_section_loading: true,
            //createPresenterLoader: false
        //});

        // JBB - 10/26/2019 - adding extra params to make welcome email work
        //let callback_base_url = window.location.protocol + '//' + window.location.hostname + '/';
        let callback_base_url = get_link_base_url();
        data.callback_url = callback_base_url + 'resetpassword';
        data.link_base_url = callback_base_url;
        let friendly_url = `${data.firstname}-${data.lastname}`;
        data.friendly_url = friendly_url.toLowerCase().replace(/ /g, "-");

        data.custom_inviter_text = this.context.user_info.nickname;
        if (this.props.custom_invitation_text) {
          data.custom_invitation_text = this.props.custom_invitation_text;
        } else {
          data.custom_invitation_text = " to be part of PechaKucha";
        }
        
        console.log("New User data",data);

        // if we have profile pic, must treat this like a combined register/getUploadSignedUrl
        let new_user_response;
        if (file) {
            new_user_response = await axios.post(`${apiUrl}users/register/nopassword?asset_type=avatar_image&filename=${file.name}`, data);
            let upload_url = new_user_response.data.upload_url;
            let content_type = new_user_response.data.content_type;
            await this.uploadPutImage(file,upload_url,content_type);
        } else {
            new_user_response = await axios.post(`${apiUrl}users/register/nopassword`, data);
        }
        
        if (!new_user_response.data.entity_uuid) {
            this.setState({
                //message: null,
                message: <span style={{color:"red", paddingTop: "10px"}}>ERROR creating new user</span>,
                //error_message: "ERROR creating new workspace user"
                loading: false
            });
            return;
        }
        
        // get new user data to display in table
        let response_data = await axios.get(`${apiUrl}users/${new_user_response.data.entity_uuid}`,myHeaders_Auth_With_Cache_Control);
        let user_data = response_data.data;
        
        user_data.entity_name = (user_data.firstname ? user_data.firstname+' ' : '')+(user_data.lastname || '');
        user_data.email = data.email;

        this.props.OnFinishCreateUser({
            //message: <span style={{color:"green", paddingTop: "10px"}}>'New User {data.email} Created and Invitation Email Sent'</span>,
            message: 'New User '+data.email+' Created and Invitation Email Sent',
            error_message: null,
            pagination_from: 0,
            search_text: "",
            insert_user: user_data
        });
        
        this.onHide();
        
        this.setState({
          loading: false
        });
    }

    // for uploading (PUT) user profile pic
    uploadPutImage = async (file, upload_url, content_type) => {
        if (!file) {
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        let profilePicPromise;
        // getting array buffer in profilePicPromise
        profilePicPromise = new Promise(resolve => {
            let reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = () => resolve(reader.result);
        });
        let profilePicPromise_response = await profilePicPromise;
        const config = {
            headers: { "Content-Type": content_type }
        };
        await axios.put(upload_url, profilePicPromise_response, config);
    }

    onHide = () => {
        this.setState({
            message: <React.Fragment></React.Fragment>,
            validated: false,
            user_data: {
                firstname: '',
                lastname: '',
                email: '',
                occupation: '',
                employer: '',
                website_url: '',
                description: ''
            },
            //selected_country_option: null,
            //selected_city_option: null,
            imagePreviewUrl: null,
            file: null,
        });
        this.props.onHide();
    }

    render() {
        /*
        if (this.state.loading) {
            return (
                <div className="createEventSpinner">
                    <ActivityIndicator theme="spinner" />
                </div>
            )
        }
        */
        
        return (
    <Modal
      style={{ color: 'black' }}
      show={this.props.show}
      onHide={this.onHide}
      //{...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
                            <Form
                            noValidate
                            validated={this.state.validated}
                            onSubmit={this.handleSubmitNewUser}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Create New User
          {/*
          {props.entity_info.entity_name}<br/>
          <span style={{ fontSize: "smaller", color: "darkgray" }}>Privacy and Sharing Settings</span>
          */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
            
                <Row className="coverphoto pad-15 venue createPresenter" style={{ marginTop: "0px !important" }} >
                    <Col lg={8}>
                        {/* <h1>Create New User</h1> */}

                            <div>
                                <div className="pad-right70">
                                    <Form.Row>
                                        <Form.Group as={Col} md="12" controlId="email">
                                            <Form.Label className="pad-r5">Email Address</Form.Label>
                                            <Form.Control
                                                required
                                                type="email"
                                                placeholder="Email Address"
                                                value={this.state.user_data.email}
                                                onChange={this.handleChangeFormValue}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a valid email address.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} md="6" controlId="firstname">
                                            <Form.Label className="pad-r5">First Name</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="First Name"
                                                value={this.state.user_data.firstname}
                                                onChange={this.handleChangeFormValue}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a first name.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="lastname">
                                            <Form.Label className="pad-r5">Last Name</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Last Name"
                                                value={this.state.user_data.lastname}
                                                onChange={this.handleChangeFormValue}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a last name.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} md="6" controlId="country">
                                            <div className="city-Dropdown">
                                                <Form.Label>Country</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    className="country-data"
                                                    value={this.state.selected_country_option}
                                                    onChange={this.handleChangeCountry}
                                                >
                                                    {
                                                        this.state.country_options.map((country) =>
                                                            <option value={country.value} key={country.value}>{country.label}</option>
                                                        )
                                                    }
                                                </Form.Control>
                                            </div>
                                        </Form.Group>

                                        <Form.Group as={Col} md="6" controlId="city">
                                            <div className="city-Dropdown">
                                                <Form.Label>City</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    value={this.state.selected_city_option}
                                                    onChange={this.handleChangeCity}
                                                >
                                                    
                                                    {
                                                        this.state.city_options.map(item => (
                                                            <option value={item.value} key={item.value}>{item.label}</option>
                                                        ))
                                                    }
                                                </Form.Control>
                                            </div>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} md="6" controlId="occupation">
                                            <Form.Label className="pad-r5">Occupation</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Occupation"
                                                value={this.state.user_data.occupation}
                                                onChange={this.handleChangeFormValue}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="employer">
                                            <Form.Label className="pad-r5">Employer</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Employer"
                                                value={this.state.user_data.employer}
                                                //defaultValue={this.props.org_data.entity_name}
                                                onChange={this.handleChangeFormValue}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md="12" controlId="website_url">
                                            <Form.Label className="pad-r5">Personal Website URL</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="https://"
                                                value={this.state.user_data.website_url}
                                                onChange={this.handleChangeFormValue}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md="12" controlId="description">
                                            <Form.Label className="pad-r5">Description</Form.Label>
                                            <Form.Control
                                                //required
                                                as="textarea"
                                                rows={4}
                                                value={this.state.user_data['description']}
                                                onChange={this.handleChangeFormValue}
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    {this.state.message}
 
                                </div>
                            </div>

                    </Col>
                    <Col lg={4}>
                        <div className="Upload form-card">
                            <div className="personal-details">
                                <div>
                                    <fieldset>
                                        <div className="input-file-row-1">
                                            <div className="upload-file-container">
                                                { this.state.imagePreviewUrl !== null ?
                                                    <img id="preview_image" src={this.state.imagePreviewUrl} alt="" />
                                                :
                                                    <img id="preview_image" src={avatar} alt="" />
                                                }
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <div className="personal-info">
                                    <div className="upload-file-container-text">
                                        <div className='one_opacity_0'>
                                            <input
                                                type="file"
                                                label="add"
                                                id="myInput"
                                                ref={(ref) => this.upload = ref}
                                                style={{ display: 'none' }}
                                                onChange={this.onChangeFile}
                                                //multiple
                                            />
                                        </div>
                                        
                                        <span
                                            label="Open File"
                                            onClick={() => { this.upload.click() }}
                                        >
                                            Add Profile Image
                                        </span>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            
      </Modal.Body>
      <Modal.Footer>
        <Button className="modal_button_white" onClick={this.onHide}>Cancel</Button>
        <Button disabled={this.state.loading} type="submit" className="modal_button">Create</Button>
      </Modal.Footer>
    </Form>
    </Modal>
        )
    }
}

function CreateNewUserModalButton (props) {
  const [modalShow, setModalShow] = React.useState(false);

  //console.log("ShareAccessModalButton",props);

  //let button_icon = props.publish_dropdown_options[props.publish_dropdown_option_index].icon;
  let button_icon = <i className="fa fa-user-plus"/>;
  //let button_text = '';
  let button_text = props.button_text || "Create New User";
  //let button_tooltip = props.publish_dropdown_options[props.publish_dropdown_option_index].tooltip;
  let button_tooltip = "";

  return (
    <React.Fragment>
        <PKButton
            //style={{ width: "150px" }}
            //data-tip={button_tooltip}
            //variant="global"
            //onClick={() => setModalShow(true)}
            OnClickMet={() => setModalShow(true)}
            theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons"
        >
        {button_icon} {button_text}
      </PKButton>

      <CreateNewUserModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        //source_info={props.source_info}
        //org_data={props.org_data}
        //user_data={props.user_data}
        custom_invitation_text={props.custom_invitation_text}
        OnFinishCreateUser={props.OnFinishCreateUser}
        //entity_info={props.entity_info}
        //publish_dropdown_options={props.publish_dropdown_options}
        //publish_dropdown_option_index={props.publish_dropdown_option_index}
        //OnChangePublishOption={props.OnChangePublishOption}
        //index={props.index}
      />
      {/*<ReactTooltip />*/}
    </React.Fragment>
  );
}

export default CreateNewUserModalButton;